<section class="abx-login">
  <div class="abx-login__bg" aria-hidden="true"></div>

  <div class="abx-login__card">
    <!-- Brand — theme-aware lockup. The card sits on --color-surface-raised, which
         is white in light mode and ocean in dark mode, so the logo variant must
         track the theme: the light variant has a navy wordmark (visible on white);
         the dark variant has a white wordmark (visible on ocean). -->
    <a routerLink="" class="abx-login__brand" aria-label="AppliedBioX home">
      <bodyanalytics-brand-logo [variant]="isDark() ? 'dark' : 'light'" [height]="40" />
    </a>

    <div class="abx-login__grid">
      <!-- Login action panel — first in DOM so it renders on top on mobile. -->
      <div class="abx-login__panel abx-login__panel--action">
        <div class="eyebrow abx-login__eyebrow">Member access</div>
        <h1 class="abx-login__heading">Access your member account</h1>
        <p class="abx-login__sub">
          Sign in to view your results, track your progress, and manage upcoming testing events.
        </p>
        <button type="button" class="btn btn-primary abx-login__cta" (click)="login.emit()">Log in / Sign up</button>
        <p class="abx-login__hint">New to AppliedBioX? Creating an account takes under a minute.</p>
      </div>

      <!-- Benefits panel — the member self-service pitch. -->
      <aside class="abx-login__panel abx-login__panel--benefits">
        <div class="eyebrow abx-login__eyebrow">Membership</div>
        <h2 class="abx-login__benefits-title">Discover AppliedBioX Membership</h2>
        <ul class="abx-login__benefits">
          <li>Access to every past hydrostatic test</li>
          <li>Detailed body-composition progress tracking</li>
          <li>Reminders about upcoming testing events</li>
        </ul>
      </aside>
    </div>

    <a routerLink="" class="abx-login__back">← Back to home</a>
  </div>
</section>
